'use strict';

var wrap$1 = require('../../../../../_virtual/wrap.js_commonjs-exports.js');

wrap$1.__exports.__esModule = true;
wrap$1.__exports.wrap = wrap;
/* eslint-disable import/prefer-default-export */

function wrap(n, min, max) {
  var d = max - min;
  return n === max ? n : ((n - min) % d + d) % d + min;
}

module.exports = wrap$1.__exports;
